<div class="flex w-full flex-col gap-1">
  @if (label()) {
    <span class="block self-start text-sm text-(--ig-editor-text-color,#ffffff)">{{ label() }}</span>
  }

  <label
    class="flex h-(--ig-editor-field-height,2.33em) w-full min-w-0 items-center gap-2.5 overflow-hidden rounded-(--ig-editor-field-radius,6px) bg-(--ig-editor-field-bg,#2b2e32) pl-0.75 pr-2 text-sm"
    [class.cursor-pointer]="!disabled() && !isTransparent()"
    [class.opacity-60]="disabled() || isTransparent()">
    <span
      class="relative aspect-4/3 h-[calc(var(--ig-editor-field-height,35px)-8px)] shrink-0 overflow-hidden rounded-(--ig-editor-field-radius,6px)">
      @if (isTransparent()) {
        <span
          class="absolute inset-0 bg-size-[8px_8px] bg-[linear-gradient(45deg,#666_25%,transparent_25%),linear-gradient(-45deg,#666_25%,transparent_25%),linear-gradient(45deg,transparent_75%,#666_75%),linear-gradient(-45deg,transparent_75%,#666_75%)]">
        </span>
      } @else {
        <span class="absolute inset-0" [style.background-color]="colorInputValue()"></span>
      }

      <input
        type="color"
        class="absolute inset-0 h-full w-full border-0 bg-transparent p-0 opacity-0"
        [class.cursor-pointer]="!disabled() && !isTransparent()"
        [class.cursor-default]="disabled() || isTransparent()"
        [disabled]="disabled() || isTransparent()"
        [value]="colorInputValue()"
        (input)="applyValue($event)" />
    </span>

    <span
      class="min-w-0 flex-1 overflow-hidden text-xs text-ellipsis whitespace-nowrap uppercase text-(--ig-editor-text-color,#ffffff)/90">
      {{ swatchLabel() }}
    </span>
  </label>
</div>
